
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/removal",
      function () {
        return require("private-next-pages/removal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/removal"])
      });
    }
  